<template>
  <div class="poster-page">
    <!-- 顶部左上角 返回按钮 -->
    <div class="top-back-area">
      <button class="back-btn" @click="goBack">返回</button>
    </div>

    <div class="main-content-wrap">
      <div class="poster-wrap">
        <div class="poster-scale-wrapper" :style="{ '--scale': posterScale }">
        <div class="poster-preview-frame" ref="posterDom" :style="frameStyle">
          <!-- 标题图片 -->
          <img
            src="@/assets/login.webp"
            class="poster-title-img"
            alt="山河留迹"
          />

          <!-- 地图容器 -->
          <div class="poster-map-box">
           <div class="map-inner-box">
            <FootprintMap
              :footData="footList"
              :groupType="currentGroupType"
              :isLogin="true"
              :isPoster="true"
            />
          </div>
         </div>

          <!-- 统计文字，新增点亮城市第三行 -->
          <div class="poster-stat">
            <div>印记总数：{{ footList.length }}</div>
            <div>足迹省份：{{ provinceCount }}</div>
            <div>点亮城市：{{ cityCount }}</div>
          </div>

          <!-- 宣传语 -->
          <div class="poster-slogan">
            {{ currentSlogan }}
          </div>
          
          <!-- 用户头像昵称，下面新增生成时间 -->
          <div class="poster-user-info">
          <img class="poster-avatar" :src="userInfo.avatar || '/default-avatar.webp'" alt="头像" />
              <div class="user-text-wrap">
                <span class="poster-username">{{ userInfo.name }}</span>
                <span class="poster-generate-time">生成于 {{ generateTime }}</span>
              </div>
          </div>

                    <!-- 二维码 -->
          <div class="poster-qr-box">
            <div class="qr-inner">
              <img v-if="qrDataUrl" :src="qrDataUrl" class="qr-img" alt="扫码访问" />
              <span v-else class="qr-placeholder">二维码</span>
            </div>
          </div>
        </div>
       </div>

        <!-- 右侧垂直按钮组：重新生成、下载海报，和海报垂直居中 -->
        <div class="right-ctrl-panel">
          <button class="regen-btn" @click="regenerate">重新生成</button>
          <button class="gen-btn" @click="createPoster">下载海报</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import html2canvas from "html2canvas";
import FootprintMap from "@/components/FootprintMap.vue";

export default {
  name: "PosterCreate",
  components: {
    FootprintMap
  },
  data() {
    return {
      bgList: [
        require("@/assets/bg-poster-1.webp"),
        require("@/assets/bg-poster-2.webp"),
        require("@/assets/bg-poster-3.webp"),
        require("@/assets/bg-poster-4.webp"),
        require("@/assets/bg-poster-5.webp")
      ],

      titleList: [
        "我的山河印记",
        "足迹地图",
        "一路向远方",
        "山河留迹",
        "走过中国"
      ],

      sloganList: [
        "印记栖心处 温情入怀时",
        "镌迹川岳间 成章步履中",
        "行万里山河 藏一隅心乡",
        "凡足迹所至 皆深情所归",
        "与子同行路 岁月自成醇"
      ],

      groupTypeList: ["lover", "child", "parent", "other"],

      currentBg: "",
      currentTitle: "",
      currentSlogan: "",
      currentGroupType: "lover",
      // 新增：海报生成日期
      generateTime: "",

      qrDataUrl: "",
      qrLink: window.location.origin + '/#/',
      userInfo: {
        avatar: "",
        name: ""
      },
      footList: [],
      posterScale: (() => {
        if (typeof window === 'undefined') return 1;
        const maxW = window.innerWidth - 160;
        const maxH = window.innerHeight - 140;
        const sw = maxW / 680;
        const sh = maxH / 305;
        return Math.max(0.3, Math.min(1.5, sw, sh));
      })() 
    };
  },
  computed: {
    provinceCount() {
      const set = new Set(this.footList.map(item => item.province));
      return set.size;
    },
    // 新增：点亮城市统计（同省份内城市去重，沿用旧海报逻辑）
    cityCount() {
      const provinceMap = {}
      this.footList.forEach(item => {
        if (!provinceMap[item.province]) {
          provinceMap[item.province] = new Set()
        }
        provinceMap[item.province].add(item.city)
      })
      let totalCity = 0
      Object.values(provinceMap).forEach(set => {
        totalCity += set.size
      })
      return totalCity
    },
    frameStyle() {
      // 固定横版海报尺寸 680 × 305，html2canvas导出使用这个尺寸
      return {
        width: "680px",
        height: "305px",
        backgroundImage: `url(${this.currentBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      };
    }
  },
   async mounted() {
    // 读真实用户信息
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    this.userInfo = {
      avatar: user.avatar || '/default-avatar.webp',
      name: user.nickname || '山河旅人'
    }
    // 读真实足迹
    try {
      const { getFootprintList } = await import('@/api/footprint.js')
      this.footList = await getFootprintList()
    } catch (err) {
      console.error('读取足迹失败', err)
      this.footList = []
    }

    const now = new Date()
    this.generateTime = now.getFullYear() + '-' + String(now.getMonth()+1).padStart(2,'0') + '-' + String(now.getDate()).padStart(2,'0')

    this.regenerate();
    await this.generateQR();
    this.calcPosterScale();
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    calcPosterScale() {
      // 屏幕可用的宽高（减去按钮区、返回按钮、边距）
      const maxW = window.innerWidth - 160;  // 右侧按钮 120 + 边距 40
      const maxH = window.innerHeight - 140; // 顶部返回按钮 + 上下边距
      const sw = maxW / 680;
      const sh = maxH / 305;
      // 允许放大到 1.5 倍，缩小不限
      this.posterScale = Math.max(0.3, Math.min(1.5, sw, sh));
    },
    handleResize() {
      this.calcPosterScale();
      this.$forceUpdate()
      this.$nextTick(()=>{
        this.$refs.posterDom?.$children?.forEach(comp=>{
          if(comp.$options.name === 'FootprintMap' && comp.chart){
            comp.chart.resize()
          }
        })
      })
    },
    goBack() {
      this.$router.push('/personal-center')
    },

    async generateQR() {
      try {
        this.qrDataUrl = await QRCode.toDataURL(this.qrLink, {
          width: 200,
          margin: 1,
          color: {
            dark: '#000000',
            light: '#ffffff'
          }
        })
      } catch (err) {
        console.error('二维码生成失败', err)
      }
    },

    randomPick(list) {
      return list[Math.floor(Math.random() * list.length)];
    },

    regenerate() {
      this.currentBg = this.randomPick(this.bgList);
      this.currentTitle = this.randomPick(this.titleList);
      this.currentSlogan = this.randomPick(this.sloganList);
      this.currentGroupType = this.randomPick(this.groupTypeList);
    },

    async createPoster() {
      const dom = this.$refs.posterDom;
      if (!dom) return;

      try {
        const canvas = await html2canvas(dom, {
          useCORS: true,
          scale: 2
        });

        const url = canvas.toDataURL("image/png");
        const a = document.createElement("a");
        a.href = url;
        // 文件名带上生成时间
        a.download = `山河印记-横版海报_${this.generateTime}.png`;
        a.click();
      } catch (err) {
        console.error("海报生成失败", err);
      }
    }
  }
};
</script>

<style scoped>
/* ============================================================
   1. 页面骨架
   ============================================================ */
.poster-page {
  min-height: 100vh;
  height: 100vh;
  padding: clamp(12px, 2vw, 20px);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  
  /* 统一全站云纹背景 */
  background-image: url("~@/assets/subtle.webp");
  background-repeat: repeat;
  background-size: 500px auto;
  background-position: center;
  background-color: rgba(247, 243, 233, 0.55);
}

/* 顶部返回按钮容器 */
.top-back-area {
  flex-shrink: 0;
  margin-bottom: clamp(12px, 2vh, 20px);
  display: flex;
  align-items: center;
}

/* ============================================================
   2. 操作按钮：高光琉璃自适应
   ============================================================ */
.back-btn {
  border-radius: 6px; 
  height: clamp(24px, 3.2vh, 28px);
  padding: 0 clamp(8px, 1.2vw, 14px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.15));
  color: #fff;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.6);
  box-shadow: 
    0 2px 6px rgba(0, 0, 0, 0.1),
    inset 0 1px 2px rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(4px);
  font-size: clamp(11px, 1.1vw, 14px);
  cursor: pointer;
  margin-left: clamp(10px, 2vw, 40px); /* 左侧留白自适应 */
  transition: all 0.2s ease;
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
}
.back-btn:hover {
  background: linear-gradient(to bottom, rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.3));
  transform: translateY(-1px);
}
.back-btn:active {
  transform: translateY(1px) scale(0.96);
}

/* ============================================================
   3. 海报容器与预览
   ============================================================ */
.main-content-wrap {
  flex: 1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.poster-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(12px, 2vw, 24px); /* 按钮和海报的间距自适应 */
  max-width: 100%;
}

/* 外层占位盒子：占缩放后的空间，撑开 flex 布局 */
.poster-scale-wrapper {
  width: calc(680px * var(--scale, 1));
  height: calc(305px * var(--scale, 1));
  position: relative;
  flex-shrink: 0;
}

/* 海报本体 */
.poster-preview-frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 680px;
  height: 305px;
  /* 换成高级的微光边框 */
  border: 2px solid rgba(255, 255, 255, 0.8);
  box-shadow: 
    0 12px 32px rgba(0, 0, 0, 0.15),
    0 0 0 1px rgba(64, 158, 255, 0.3); /* 加一层极细的蓝色外发光 */
  border-radius: 16px;
  overflow: hidden;
  transform: scale(var(--scale, 1));
  transform-origin: top left;
  transition: transform 0.2s ease-out; 
}

/* ============================================================
   4. 右侧垂直操作按钮组（高光琉璃）
   ============================================================ */
.right-ctrl-panel {
  display: flex;
  flex-direction: column;
  gap: clamp(12px, 2vh, 20px);
  flex-shrink: 0;
}

.regen-btn,
.gen-btn {
  /* 👇 瘦身核心1：减小内边距，控制高度和宽度 */
  padding: clamp(4px, 0.8vh, 6px) clamp(10px, 1.2vw, 14px);
  border-radius: 8px;
  cursor: pointer;
  
  /* 👇 瘦身核心2：字号也稍微压一点，最大不超过 14px */
  font-size: clamp(11px, 1vw, 13px);
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  transition: all 0.2s ease;
  border: 1px solid rgba(255, 255, 255, 0.4);
  text-shadow: 0 1px 2px rgba(0,0,0,0.15);
  backdrop-filter: blur(4px);
  
  /* 👇 瘦身核心3：强制宽度自适应，但在大屏上不要被拉得太宽 */
  width: clamp(80px, 10vw, 110px); 
  display: flex;
  justify-content: center;
  align-items: center;
}

/* 重新生成：绿色琉璃 */
.regen-btn {
  background: linear-gradient(to bottom, rgba(255,255,255,0.25), rgba(255,255,255,0) 50%), rgba(82, 196, 26, 0.85);
  box-shadow: 0 4px 12px rgba(82, 196, 26, 0.25), inset 0 1px 2px rgba(255, 255, 255, 0.5);
}
.regen-btn:hover {
  background: linear-gradient(to bottom, rgba(255,255,255,0.35), rgba(255,255,255,0) 50%), rgba(82, 196, 26, 0.95);
  transform: translateY(-1px);
}

/* 下载海报：蓝色琉璃 */
.gen-btn {
  background: linear-gradient(to bottom, rgba(255,255,255,0.25), rgba(255,255,255,0) 50%), rgba(64, 158, 255, 0.85);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.25), inset 0 1px 2px rgba(255, 255, 255, 0.5);
}
.gen-btn:hover {
  background: linear-gradient(to bottom, rgba(255,255,255,0.35), rgba(255,255,255,0) 50%), rgba(64, 158, 255, 0.95);
  transform: translateY(-1px);
}

.regen-btn:active,
.gen-btn:active {
  transform: translateY(1px) scale(0.96);
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.2);
}
/* ============================================================
   5. 海报内部元素（像素级锁定，为了保证导出的图片不乱）
   ============================================================ */
.poster-title-img {
  position: absolute;
  top: 17px;
  left: 24px;
  width: 130px;
  height: auto;
  z-index: 6;
  display: block;
}

.poster-map-box {
  position: absolute;
  top: 15px;
  width: 85%;
  height: calc(100% - 32px);
  border-radius: 14px;
  overflow: hidden;
  background: transparent;
  transform: translateX(-20%);
  transform-origin: center center;
}

/* 足迹统计：升级为毛玻璃小卡片 */
.poster-stat {
  position: absolute;
  right: 115px;
  bottom: 15px;
  color: #ffffff;
  font-size: 13px;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
  border: 1px solid rgba(255, 255, 255, 0.15);
  padding: 4px 8px;
  border-radius: 8px;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.5);
  z-index: 6;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2);
  line-height: 1.5;
}

.poster-slogan {
  position: absolute;
  left: 55%;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  
  /* 👇 字号缩小到 18px（在 680 的画布里绝对够大，又不会折行） */
  font-size: 18px;
  font-weight: bold;
  color: #fff5b5;
  font-family: "STKaiti", "KaiTi", "华文行楷", "Microsoft YaHei", sans-serif;
  letter-spacing: 2px;
  text-shadow:
    0 0 8px rgba(255, 120, 60, 0.9),
    0 2px 10px rgba(0, 0, 0, 0.6);
  z-index: 6;
  
  /* 👇 核心防爆框：强制在一行显示，如果太长就显示省略号 */
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 用户信息 */
.poster-user-info {
  position: absolute;
  right: 22px;
  top: 15px;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  z-index: 6;
}
.user-text-wrap {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.poster-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #fff;
  object-fit: cover;
  box-shadow: 0 2px 8px rgba(0,0,0,0.35);
  margin-top: 5px;
}
.poster-username {
  color: #ffffff;
  font-size: 13px;
  text-shadow: 0 1px 4px rgba(0,0,0,0.5);
}
.poster-generate-time {
  color: #ffffff;
  font-size: 11px;
  opacity: 0.9;
  text-shadow: 0 1px 4px rgba(0,0,0,0.5);
}

/* 二维码区域：外加了一点玻璃质感边框 */
.poster-qr-box {
  position: absolute;
  right: 40px;
  bottom: 18px;
  width: 56px;
  z-index: 7;
  text-align: center;
}
.qr-inner {
  width: 65px;
  height: 65px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.92);
  border: 2px solid #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.18), inset 0 1px 2px rgba(255,255,255,1);
}
.qr-placeholder {
  font-size: 12px;
  color: #999;
}
.qr-img {
  width: 100%;
  height: 100%;
  display: block;
  border-radius: 8px;
}

.map-inner-box {
  width: 100%;
  height: 100%;
 
}
</style>